function normalizeReportIds(ids) {
    return Array.from(new Set((Array.isArray(ids) ? ids : []).map(Number)
        .filter(id => Number.isSafeInteger(id) && id > 0))).sort((a, b) => a - b);
}

module.exports = {normalizeReportIds};
